Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useGetCurrentThemeId = void 0;

var getters_1 = require("./getters");

var admin_core_1 = require("@wheelroom/admin-core");

var react_1 = require("react");

exports.useGetCurrentThemeId = function () {
  var _react_1$useContext = react_1.useContext(admin_core_1.AdminCoreContext),
      adminCoreState = _react_1$useContext.adminCoreState;

  var themeSwitcherStore = getters_1.getThemeSwitcherStore(adminCoreState);
  return themeSwitcherStore === null || themeSwitcherStore === void 0 ? void 0 : themeSwitcherStore.state.activeThemeId;
};